import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { isLoggedIn } from 'state/selectors/user';
import ExternalResourceIcon from './main';

const selector = createSelector(isLoggedIn, (isUserLoggedIn) => ({
    isUserLoggedIn,
}));

export default connect(selector, {})(ExternalResourceIcon);
